<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(identificativo)="{ item }">
                        <router-link class="sa-edit-link" :to="'/cot/richieste/edit/' + item.cotBean.id">{{ item.cotBean.identificativo }}</router-link>
                    </template>
                    <template v-slot:cell(nominativo)="{ item }">{{ item.cotBean.cognome }} {{ item.cotBean.nome }}</template>
                    <template v-slot:cell(data)="{ item }">
                        <span v-if="item.cotBean.statoAttuale !== 'NON INOLTRATA'">{{ formatDate(item.cotBean.statoAttualeDataOra) }}</span>
                        <span v-else>---</span>
                    </template>
                    <template v-slot:cell(provenienzaNominativoMedico)="{ item }">
                        <span class="sa-label-data-secondary">{{ item.cotBean.provenienzaDescrizioneStruttura }}</span>
                        <span class="sa-label-data-secondary">{{ item.cotBean.provenienzaDescrizioneReparto }}</span>
                    </template>
                    <template v-slot:cell(stato)="{ item }">
                        <span>{{ item.cotBean.statoAttuale }}</span>
                    </template>
                    <template v-slot:cell(statoMessaggio)="{ item }">
                        <span :class="getClassAlert(item)">{{ item.statoMessaggio }}</span>
                    </template>
                    <template v-slot:cell(color)="{ item }">
                        <span :class="getClassAlert(item)"><b-icon icon="circle-fill"></b-icon></span>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
// import Vue from "vue";
import axios from "axios";
import moment from "moment";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/cotalert",
            linkedit: "",
            filtro: {},
            items: [],
            listKey: 0,
            fields: [
                {
                    label: "Codice Fiscale",
                    key: "identificativo",
                    sortable: true,
                },
                {
                    label: "Nominativo",
                    key: "nominativo",
                    sortable: true,
                },
                {
                    label: "Data Segnalazione",
                    key: "data",
                    thStyle: "width: 8rem",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: true,
                },
                {
                    label: "Messaggio",
                    key: "statoMessaggio",
                    sortable: true,
                },
                {
                    label: "",
                    key: "color",
                    sortable: false,
                },
            ],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtro"]) {
            me.filtro = JSON.parse(sessionStorage["filtro"]);
        }
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;

                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        getClassAlert(item) {
            let returnValue = "sa-alert-normal";
            switch (item.stato) {
                case "DANGER":
                    returnValue = "sa-alert-danger";
                    break;
                case "WARNING":
                    returnValue = "sa-alert-warning";
                    break;
            }

            return returnValue;
        },
    },
};
</script>

<style>
.sa-alert-danger {
    color: red;
    font-weight: bold;
}
.sa-alert-warning {
    color: orange;
    font-weight: bold;
}
</style>
